import { Bets } from '@/components/Bets';
import { Box, Tabs } from '@mantine/core';
import { ProfileUser } from '../ProfileUser';
import { OverviewStatistic } from './OverviewStatistic';
export const Overview: React.FC = () => {
  return <Tabs.Panel value="overview">
      <ProfileUser />
      <OverviewStatistic />
      <Box mt={20}>
        <Bets />
      </Box>
    </Tabs.Panel>;
};